import cookies from '../helpers/cookies';

const $modal = $('#autoOpenModal');

export default {
  initialize() {
    if (!$modal.length) {
      return;
    }

    $modal.on('hide.bs.modal', () => {
      cookies.set('image-modal', '1', 0.1);
    });
  },
};
